import { Box, Divider, Stack, Typography } from "@mui/material";
import { colours } from "../../shared/colors";
import EditIcon from "../icons/EditIcon";

const CreateQuoteCardHeader = ({ title }: { title: string }) => (
	<>
		<Stack direction="row" px={"1.5em"} py={"1em"} alignItems="center">
			<Box pr={"0.5em"} alignItems="center">
				<EditIcon
					fill={colours.primaryLight.main}
					style={{ color: colours.primaryLight.main }}
					sx={{ fontSize: "1.25em" }}
				/>
			</Box>
			<Typography variant="quoteTabHeader">{title}</Typography>
		</Stack>
		<Divider light />
	</>
);

export default CreateQuoteCardHeader;
